import React from "react";

export default function ScrollBox({
  children,
  height = 420, // match old UI feeling
  className = "",
}) {
  return (
    <div
      className={
        "relative overflow-y-scroll rounded-xl border border-palette-gray-divider bg-white " +
        "pr-2 " +
        className
      }
      style={{
        height,
        scrollbarGutter: "stable", // prevents layout shift
      }}
    >
      {children}
    </div>
  );
}
